import React from "react";
import HelpCategories from "../help/help-categories";
import HelpSearch from "../help/help-search";
import Faq from "../faq/faq";
import "../help/help.scss";
import { useCommonContext } from "../../context/common-context";
import { BreadCrumb } from "../../common/breadcrumb";

import { routes, routeTitle } from "../help/constants";
import { getBannerDisplayName } from "../../../helpers/banner";

const AllFaq = ({}) => {
  const {
    bannerCategories,
    bannerFAQ,
    user,
    appData: { banner: bannerName },
    isGuest,
  } = useCommonContext();

  const banner = getBannerDisplayName(bannerName);
  const isAllFaqPage = window.location.pathname.split("/").includes("all-faq");
  let filterBy = "topFaq";

  let id, title;

  const childFaqRoutes = Object.values(routes);
  const pathname = window.location.pathname.split("/").pop();
  if (childFaqRoutes && childFaqRoutes.includes(pathname)) {
    const title = routeTitle[pathname];
    const { id: catId, topFaq } = bannerCategories.find(
      (cat) => cat.title === title
    );
    id = catId;
    filterBy = topFaq ? "topFaq" : "parentId";
  }

  const filteredFaq = Array.from(bannerFAQ).filter((list) => {
    return list.category.includes(Number(id));
  });
  const list = bannerCategories.find((list) => list.id.toString() == id);
  const categoryName = list.title.replace(/{banner}/g, banner);

  const breadCrumblist = [
    {
      label: "Contact Us",
      href: "/help/home",
    },
    {
      label: isAllFaqPage ? "All FAQs" : categoryName,
    },
  ];
  title =
    filterBy === "topFaq"
      ? "Top FAQs (Frequently Asked Questions)"
      : categoryName;
  const pageTitle =
    filterBy === "topFaq"
      ? `Answers to your ${categoryName}`
      : `Here are other ${categoryName}-related questions:`;

  return (
    <div className="help-wrapper">
      <BreadCrumb list={breadCrumblist} />
      { filterBy == "topFaq" && <HelpSearch isGuest={isGuest} banner={banner} /> }
      <h2 className="font-family-Helvetica mt-4 font-weight-600">{title}</h2>
      <HelpCategories
        filterBy={filterBy}
        id={id}
        isGuest={isGuest}
        banner={banner}
        user={user}
      />
      <h3 className="font-family-Helvetica mb-4">{pageTitle}</h3>
      <div className="mx-n1 px-1">
        <Faq faq={filteredFaq} />
      </div>
    </div>
  );
};

export default AllFaq;
